import { useEffect } from 'react'

/** Sets document.title for the page, restoring the base title on unmount. */
export function usePageTitle(title: string) {
  useEffect(() => {
    const base = 'Break Glass'
    document.title = title ? `${title} — ${base}` : base
    return () => {
      document.title = `${base} — A ceremony orchestrator for your secrets`
    }
  }, [title])
}
